module.exports = __webpack_public_path__ + "static/img/H24_1.c223756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H24_1.png
// module id = Cc15
// module chunks = 0